import React, {memo, useEffect} from 'react';
import styles from './styles.module.scss';
import useCourtVerification from "@/app/features/court_verification_page/slice";
import CourtInfoWidget from "@/app/components/court_info_widget/widget";
import {ThirtyText} from "@/app/components/texts";
import {t} from "i18next";
import {s} from "@/app/utils/s";
import classNames from "classnames";
import CircularProgressIndicator from "@/app/components/circular_progress_indicator";

const CourtVerification = () => {
  const {state, init, onApprove, onReject} = useCourtVerification();

  useEffect(() => {
    init();
  }, []);

  return (
    <div className={classNames(styles.use_court_verification, {[styles.notEmpty]: state.courts.length > 0})}>
      {state.hasLoading && <div className={styles.centered}><CircularProgressIndicator isGreen/></div>}
      {state.hasError && <div className={styles.centered}><ThirtyText text={t(s.noAccess)}/></div>}
      {!state.hasError && !state.hasLoading && state.courts.length === 0 &&
          <div className={styles.emptyPage}><ThirtyText text={t(s.noLocations)}/></div>}
      {state.courts.map((item, index) => <div>
        <CourtInfoWidget goToCreateMatch={() => {
        }} data={item} courtOnMatch={true} key={index} onApprove={() => onApprove(item.id)}
                         onReject={() => onReject(item.id)}/>
      </div>)}
    </div>
  );
};

export default memo(CourtVerification);
